import { useState, useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import UIContext from '../../context/UIContext';
//
import Header from './header';
import Nav from './nav';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;
const NAV_WIDTH = 280; // Sidebar width

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme, opennav }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 15,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    // marginLeft: opennav ? `${NAV_WIDTH}px` : '0px', // Adjust margin based on sidebar
    width: opennav ? `calc(100% - ${NAV_WIDTH}px)` : '100%', // Adjust width based on sidebar
  },
}));

// const Main = styled('div')(({ theme, opennav }) => ({
//   flexGrow: 1,
//   overflow: 'auto',
//   minHeight: '100%',
//   paddingTop: APP_BAR_MOBILE + 24,
//   paddingBottom: theme.spacing(10),
//   width: `calc(100% - ${opennav ? NAV_WIDTH : 0}px)`,
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   [theme.breakpoints.up('lg')]: {
//     paddingTop: APP_BAR_DESKTOP + 24,
//     paddingLeft: theme.spacing(2),
//     paddingRight: theme.spacing(2),
//   },
// }));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(true);
  const { setNavOpen } = useContext(UIContext);

  useEffect(() => {
    setNavOpen(open);
  }, [open]);

  return (
    <StyledRoot>
      <Header onopennav={() => setOpen(!open)} opennav={open} />

      <Nav opennav={open} onCloseNav={() => setOpen(false)} />
      
      <Main opennav={open}>
        <Outlet />
      </Main>
      
    </StyledRoot>
  );
}
